<template>
  <div class="research-detail" v-if="research">
    <!-- 返回按钮 -->
    <button @click="goBack">返回</button>

    <!-- 标题 -->
    <h1>{{ research.title }}</h1>

    <!-- 介绍 -->
    <p style="text-indent: 2em">{{ research.description }}</p>

    <!-- 主要图片 -->
    <div class="image-section">
      <img :src="research.image" :alt="research.title" />
    </div>

    <!-- 详情内容 -->
    <p v-for="(detail, index) in research.details" :key="index" style="text-indent: 2em">
      {{ detail }}
    </p>

    <!-- 列表 -->
    <ul v-if="research.list">
      <li v-for="(item, index) in research.list" :key="index">{{ item }}</li>
    </ul>

    <!-- 额外图片 -->
    <div class="image-section" v-if="research.extraImages">
      <img v-for="(img, index) in research.extraImages" :key="index" :src="img" alt="Extra Image" />
    </div>

    <!-- 结论 -->
    <p v-if="research.conclusion" style="text-indent: 2em">
      <strong>{{ research.conclusion }}</strong>
    </p>

    <!-- 视频 -->
    <div class="video-section" v-if="research.video">
      <video controls>
        <source :src="research.video" type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResearchDetail",
  props: ["id"], // 通过路由参数获取 ID
  data() {
    return {
      research: null, // 存储研究详情数据
    };
  },
  async mounted() {
    await this.fetchResearchDetail();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 获取研究详情数据
    async fetchResearchDetail() {
      try {
        const response = await fetch("/researchdetail.json");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Fetched Research Detail Data:", data);

        // 根据 ID 查找相应的研究方向
        const researchId = Number(this.id);
        this.research = data.find((item) => item.id === researchId) || null;
      } catch (error) {
        console.error("获取研究详情数据失败:", error);
      }
    }
  }
};
</script>

<style scoped>
button {
  padding: 0.5rem 1.25rem; /* 8px 20px -> 0.5rem 1.25rem */
  background-color: #8a0b0b;
  color: white;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 3.125rem; /* 50px -> 3.125rem */
}

button:hover {
  background-color: #0056b3;
}

.research-detail {
  padding: 1.25rem; /* 20px -> 1.25rem */
}

.research-detail h1 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.0625rem; /* 1px -> 0.0625rem */
  color: rgb(0, 0, 0);
  padding: 1.25rem; /* 20px -> 1.25rem */
  border-radius: 0.625rem; /* 10px -> 0.625rem */
  margin-top: 0.625rem; /* 10px -> 0.625rem */
  text-align: center;
}

.image-section {
  text-align: center;
  margin: 1.25rem 0; /* 20px -> 1.25rem */
}

.image-section img {
  max-width: 80%;
  height: auto;
  border-radius: 0.5rem; /* 图片圆角 */
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.video-section {
  text-align: center;
  margin: 1.25rem 0; /* 20px -> 1.25rem */
}

.video-section video {
  max-width: 80%;
  height: auto;
  border-radius: 0.5rem; /* 8px -> 0.5rem */
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1); /* 10px 30px -> 0.625rem 1.875rem */
}
</style>
